var _style, _path, _path2, _ellipse, _ellipse2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCcStudent = function SvgCcStudent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "cc-student_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 300 300"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cc-student_svg__st7{fill:#ffd040}.cc-student_svg__st9{fill:#366aff}.cc-student_svg__st10{fill:#224bbe}")), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 150,
    style: {
      fill: "#abd5fa"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.7 214.1v75.4c17.1 6.8 35.8 10.5 55.3 10.5s38.2-3.7 55.3-10.5v-75.4H94.7",
    className: "cc-student_svg__st9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7 214.1v42.6c12.4 18.3 30.7 25.9 55.3 25.9s42.9-7.6 55.3-25.9v-42.6z",
    className: "cc-student_svg__st10"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.7,
    cy: 174.7,
    className: "cc-student_svg__st9",
    rx: 22.6,
    ry: 18.5,
    transform: "rotate(-57.049 230.737 174.692)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.3,
    cy: 174.7,
    className: "cc-student_svg__st9",
    rx: 18.5,
    ry: 22.6,
    transform: "rotate(-32.951 69.276 174.69)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.6 159.3c0 57.8-25.7 106.2-79.6 106.2S70.4 217 70.4 159.3 83.9 54.7 150 54.7c64.7 0 79.6 46.9 79.6 104.6",
    className: "cc-student_svg__st9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.9 183.9c1.1-4.9 1.7-10 1.7-15.3 0-1.4 0-2.8-.1-4.1-.2 6.6-.7 13.1-1.6 19.4M70.4 168.6c0 5.2.6 10.4 1.7 15.3-.9-6.3-1.4-12.9-1.6-19.5 0 1.4-.1 2.8-.1 4.2",
    className: "cc-student_svg__st9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71 100.9c0-43.7 35.4-79 79-79s79 35.4 79 79z",
    className: "cc-student_svg__st7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71 100.9h158c0-12.5-2.9-24.3-8.1-34.8H79c-5.1 10.5-8 22.3-8 34.8",
    style: {
      fill: "#edb20a"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M226.4 117.2H73.6c-5.5 0-10-4.5-10-10V79.8h172.8v27.4c0 5.5-4.5 10-10 10",
    className: "cc-student_svg__st7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.2 218.6c8.1 12.1 23.1 18.7 38.2 15.4s26-15.5 28.3-30z",
    className: "cc-student_svg__st10"
  })));
};
export default SvgCcStudent;